







import { Component, Prop, Vue } from 'vue-property-decorator';

/** 设置面板字段行壳：复用全局 .wheel-setting-item/.wheel-setting-field 约定，不写新样式 */
@Component
export default class PopField extends Vue {
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, default: '' }) col!: '' | '8' | '10' | '12';
}
